<template lang="pug">
  .Paragraph
    .Paragraph_more(v-if="more")
      p.Paragraph_more_title(v-if="more.title" v-html="more.title")
      .sep(v-if="more.title")
      p.Paragraph_more_content(v-if="more.content" v-html="more.content")

    p.Paragraph_epigraph(v-if="epigraph" v-html="epigraph")

    .Paragraph_text(v-if="item.description")
      h4.Paragraph_text_title(v-if="item.title" v-html="item.title")
      p.Paragraph_text_content(v-if="item.description" v-html="item.description")

    .Paragraph_highlight(v-if="highlight")

      img.Paragraph_highlight_picture(v-if="highlight.picture" :src="highlight.picture")

      .Paragraph_highlight_text(:class="{ 'with-picture': highlight.picture }")
        h4.Paragraph_highlight_title(v-if="highlight.title" v-html="highlight.title")
        p.Paragraph_highlight_content(v-if="highlight.content" v-html="highlight.content")

    ButtonSimple(:to="link.to", v-if="link") {{ link.label }}
</template>

<script>

import ButtonSimple from '@/components/common/ButtonSimple'

export default {
  props: ['item', 'text', 'quote', 'link', 'push', 'more', 'epigraph', 'highlight'],
  components: { ButtonSimple },
  data () {
    return {}
  },
  mounted () {
    let p = this.$el.querySelectorAll('p')
    for (let i = 0; i < p.length; i++) {
      this.$parallax.set(p[i], { y: 0 }, { y: 30 }, { y: -30 })
    }

    // let img = this.$el.querySelectorAll('img')
    // for (let i = 0; i < img.length; i++) {
    //   this.$parallax.set(img[i], { y: 0 }, { y: 60 }, { y: -60 })
    // }
  },
  beforeDestroy () {
    let p = this.$el.querySelectorAll('p')
    for (let i = 0; i < p.length; i++) {
      this.$parallax.remove(p[i])
    }

    // let img = this.$el.querySelectorAll('img')
    // for (let i = 0; i < img.length; i++) {
    //   this.$parallax.remove(img[i])
    // }
  }
}

</script>

<style lang="stylus">

  .Paragraph
    box-sizing border-box
    display flex
    flex-direction row
    justify-content center
    align-items center
    margin auto
    // margin 130px auto
    width 100%

    &-margin
      margin 30px auto

      @media $mq_m
        margin 45px auto

      @media $mq_l
        margin 60px auto

    .ButtonSimple

      border-color $black
      color $black
      transition background-color 0.6s $ease

      &:hover

        background-color $black
        color white

    // &:nth-child(1)

    //   padding-top 0px

    // &_quote

    //   width 340px
    //   min-width 340px
    //   position relative
    //   box-sizing border-box
    //   margin auto 50px auto auto

    //   &_content

    //     font-size: 28px;
    //     line-height: 45px;
    //     font-family: 'Sectra Display'

    //   img

    //     width 77px
    //     height 63px
    //     position absolute
    //     left 0px

    //     &.top

    //       top -115px

    //     &.bottom

    //       bottom -115px

    &_highlight

      background-color $beige
      width 100%
      display flex
      position relative
      flex-direction row
      justify-content center
      align-items center
      box-sizing border-box
      padding 50px

      &_picture

        width 290px
        margin auto 40px auto 0px

      &_text

        width 100%
        margin auto
        text-align center

        &.with-picture

          text-align left

        &_content

          font-weight 200
          font-size: 20px;
          line-height: 40px;

    &_text

      max-width 720px
      width 100%

      &_content

        font-weight 200
        font-size: 20px;
        line-height: 40px;

      a

        text-decoration underline
        font-weight 600
        color $black

    &_push

      width 100%
      font-size: 28px;
      max-width 720px
      font-family: 'Sectra Display'
      line-height: 45px;

    &_epigraph

      width 100%
      padding 15px 35px
      box-sizing border-box
      border-left: 5px solid $black
      max-width 720px
      font-size: 22px;
      line-height: 40px;

    &_more

      width 340px
      min-width 340px
      padding 80px 50px
      position relative
      box-sizing border-box
      background-color $black
      text-align center
      color $beige
      margin auto 50px auto auto

      .sep

        background-color $beige

      &:after

        content ''
        position absolute
        top 10px
        left 10px
        border 1px solid $beige
        width calc(100% - 20px)
        height calc(100% - 20px)

      &_content

        font-weight 200
        font-size: 18px;
        letter-spacing: 1px;
        line-height: 40px;

      &_title

        font-size: 18px;
        text-transform uppercase
        letter-spacing: 1.8px;
        line-height: 35px;

</style>
